/**
 * applies the selected filters to the available cards.
 *
 * selected options within individual filters should be applied using "OR"
 * logic and merging of different filters should be applied using "AND" logic.
 *
 * NB: In case the length of selected options within a filter is 0, then ALL
 * values should be considered valid.
 */
function applyFilters(cards, filters) {
  return cards.filter(card => {
    const matchesGrades = filters.selectedGrades.length === 0 || card.meta.grades.some(grade => filters.selectedGrades.includes(grade.id));
    const matchesCourses = filters.selectedCourseCounts.length === 0 || filters.selectedCourseCounts.some(courseCount => courseCount.from <= card.meta.courseCount && card.meta.courseCount <= courseCount.to);
    return matchesGrades && matchesCourses;
  });
}

export { applyFilters };
//# sourceMappingURL=util.apply-filters.js.map
